import React from 'react'
import PropTypes from 'prop-types'

import { SLIDE_CONTAINER_WIDTH, SLIDE_NAV_WIDTH } from 'Constants/Swipers'

import { ArrowIcon, Container, NavButtonNext, NavButtonPrev } from './styles'

function Navigation({ handlerClickPrev, handlerClickNext, offset, secondary }) {
  return (
    <Container width={offset ? 1 : SLIDE_CONTAINER_WIDTH}>
      <NavButtonPrev
        aria-label="Previous slide"
        secondary={secondary}
        width={offset ? [0, 0, 50, 60, 60, 60, 60, 130] : SLIDE_NAV_WIDTH}
        onClick={handlerClickPrev}
      >
        <ArrowIcon />
      </NavButtonPrev>

      <NavButtonNext
        aria-label="Next slide"
        secondary={secondary}
        width={offset ? [0, 0, 50, 60, 60, 60, 60, 130] : SLIDE_NAV_WIDTH}
        onClick={handlerClickNext}
      >
        <ArrowIcon angle={180} />
      </NavButtonNext>
    </Container>
  )
}

Navigation.defaultProps = {
  offset: false,
  secondary: false,
}

Navigation.propTypes = {
  handlerClickNext: PropTypes.func.isRequired,
  handlerClickPrev: PropTypes.func.isRequired,
  offset: PropTypes.bool,
  secondary: PropTypes.bool,
}

export default Navigation
